const initialState = {
  plansetData: {'attachments': []},
  currentPlansetViewTab: 'New',
  refreshPlansetComments: true
};

export const PlansetReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PLANSET':
      return { ...state, plansetData: action.payload };
    case 'SET_VIEW_TAB':
      return { ...state, currentPlansetViewTab: action.payload };
    case 'SET_REFRESH_PLANSET_COMMENTS':
      return { ...state, refreshPlansetComments: action.payload };
     case 'RESET_STATE':
      return initialState; //reset to default
    default:
      return state;
  }
};

export const setPlanset = (plansetData) => (
    { type: "SET_PLANSET", payload: plansetData }
);
export const setPlansetViewTab = (currentTab) => (
    { type: "SET_VIEW_TAB", payload: currentTab }
);

export const setRefreshPlansetComments = (value) => (
    { type: "SET_REFRESH_PLANSET_COMMENTS", payload: value }
);

export const resetState = () => ({
  type: 'RESET_STATE',
});